import styled from "@emotion/styled"
import React from 'react'
import { Colors } from '../../styles/colors'
import { Visibility } from '../../styles/spacing'
import { blogName, CATEGORY_ENUM} from '../../utils/blog/const'
import { SiteLink } from '../SiteLink'
import { CATEGORIES_MAP, Category, CATEGORY_SIZES } from './Categories'

// Va gestita immagine
const StyledCategoryCard = styled.div`
  height: 141px;
  flex-grow: 0;
  flex-basis: 342px;
  max-width: 342px;
  border-radius: 16px;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  display: flex;
  background-repeat: no-repeat;
  background-position: center;
  transition: 0.1s all;
  :hover, :active {
    transform: scale(0.96);

  }
`

export const CategoryCard = ({ type}) => {
  const category = CATEGORIES_MAP[type]
  return <SiteLink css={Visibility.mobileNoSelect} to={`/${blogName}/${category.categoryPath}/`} internal name={category.label}>
      <StyledCategoryCard className={'drop-shadow-100'} style={{backgroundImage: `url(${category.image})`}}>
              <Category category={category.ghostSlug} size={CATEGORY_SIZES.large} css={Colors.Color.eerieBlack0}/>
      </StyledCategoryCard>
    </SiteLink>
}
